import { PageHeader } from "@/components/AppShell";
import { DataTable, fmtDate } from "@/components/admin/DataTable";

const show = (v) => (v == null ? "—" : JSON.stringify(v));

export default function AuditPage() {
  const columns = [
    { key: "created_at", label: "When", sortable: true, defaultSort: true, render: (r) => fmtDate(r.created_at) },
    { key: "actor_email", label: "Who", sortable: true },
    { key: "action", label: "Action", sortable: true },
    { key: "details", label: "Details" },
    { key: "change", label: "Before → After", render: (r) => <span className="block max-w-xs break-words font-mono text-xs text-slate-700">{show(r.before)} → {show(r.after)}</span> },
  ];
  return (
    <div>
      <PageHeader eyebrow="Admin Control Centre" title="Audit log" />
      <p className="mb-4 text-sm text-slate-700">A read-only record of important admin actions. Entries cannot be edited or deleted.</p>
      <DataTable endpoint="/admin/audit" columns={columns} rowKey="id" csvName="crowlearn-audit" testid="audit-table" />
    </div>
  );
}
